module.exports = __webpack_public_path__ + "img/karriere-weiterbildung-sales.fe76b036.jpg";